// mutations
export const EDITOR_INIT = 'Initialize editor'
export const EDITOR_CLEAR = 'Clear editor'
export const EDITOR_SET_SCHEMA = 'Set editor schema'
export const EDITOR_SET_DATA = 'Set editor data'
export const EDITOR_SET_FIELD_DATA = 'Set editor field'
export const EDITOR_SET_VAULT = 'Set editor vault'
export const EDITOR_SET_ICON = 'Set editor icon'
export const EDITOR_SET_TAG_DATA = 'Set editor tags'
export const EDITOR_SET_ERRORS = 'Set editor field errors'
export const EDITOR_TOGGLE_TOP_LEVEL = 'Toggle editor top-level'
export const EDITOR_SET_TOP_LEVEL = 'Set editor top-level'
export const EDITOR_ADD_TAG = 'Add new tag'
export const EDITOR_RESTORE_FIELD = 'Restore editor field'
export const EDITOR_MARK_SYNCING = 'Syncing fields'
export const EDITOR_MARK_SYNCED = 'Sync Complete'
export const EDITOR_RESET_STATUSES = 'sync status cleared'
export const EDITOR_FORCE_RESET_STATUSES = 'Force clear sync status'
export const EDITOR_SET_SHARING = 'Set entry sharing'
export const EDITOR_SET_TAG_OPTIONS = 'Set tag options'

// actions
export const ENTRY_LOAD = 'Load entry'
export const ENTRY_LOAD_DATA = 'Load entry from data'
export const ENTRY_UPDATE_MODEL = 'Update model'
export const ENTRY_REFRESH = 'Refresh entry'
export const ENTRY_UPDATE = 'Update entry'
export const ENTRY_INSERT = 'Insert entry'
export const ENTRY_DELETE = 'Delete entry'
export const RESET_EDITOR = 'Reset editor'
export const EDITOR_LOAD_TAG_OPTIONS = 'Load tag options'
